interface Error {
  message?: string
}

const codeByMessage = (err: Error): string | null => {
  if (err?.message?.includes('ENFORCE_CUSTOMER_PHONE_VALIDATION_FAILED')) {
    return 'ENFORCE_CUSTOMER_PHONE_VALIDATION_FAILED'
  }
  if (err?.message?.includes('UNAUTHORIZED')) {
    return 'UNAUTHORIZED'
  }
  return null
}

export default codeByMessage
